import React from 'react';
import {useNavigate} from 'react-router-dom';
import './regulations.css';
import ButtonComponent from '../../../shared/button/Button.component';

interface RegulationsProps {
    t: (key: string) => string;
}

const Regulations: React.FC<RegulationsProps> = ({t}) => {

    const navigate = useNavigate();

    const goBackHandler = () => {
        navigate('/login');
    }

    return (
        <div className="regulations__main-wrapper">

            <div className="regulations__go-back__wrapper">
                <ButtonComponent id="resultsGoBackButton"
                                 value="<<"
                                 className="go-back_next__button"
                                 onClick={goBackHandler}/>
            </div>

            <div className="regulations__inner_wrapper">

                <div className="regulations_headline">
                    {t('regulations_headline')}
                </div>

                <div className="regulations_paragraph" dangerouslySetInnerHTML={{ __html: t('regulations_paragraph') }} />

                <div className="regulations_signature" dangerouslySetInnerHTML={{ __html: t('regulations_signature') }} />

                <div className="regulations_disclaimer" dangerouslySetInnerHTML={{ __html: t('regulations_disclaimer') }} />

            </div>







        </div>
    );
}

export default Regulations;
